import { useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import AlertService from "../../services/AlertService";


const Alert = () => {
    const toast = useRef(null);

    useEffect(() => {
         const subscription = AlertService.alert.subscribe((alert) => {
    if (alert?.detail && alert.detail.trim() !== "") {
        toast.current.show(alert);
    }
});

        return () => subscription.unsubscribe();
    }, []);

    useEffect(() => {
        AlertService.clear();
    }, []);

    return (
        <Toast
            ref={toast}
            position="top-right"
            className="custom-toast"
            breakpoints={{
                '960px': { width: '90%', right: '5%', top: '80px' }
            }}
        />
    );
};

export default Alert;
